<template>
  <div>
    <template v-if="$store.getters.selectedTab=='ckone'">
      <div class="btn-group-hdr">
        <div class="btn-group btn-group-toggle">
          <!--<button v-if="images.length>0" type="button" class="btn btn-secondary btn-sm" @click="removeAllImages" data-toggle="tooltip" data-placement="bottom" title="Remove All Images"><i class="fas fa-times"></i>&nbsp;Remove All</button>-->
          <!--<button v-if="images.length>0" type="button" class="btn btn-secondary btn-sm" @click="searchImages" data-toggle="tooltip" data-placement="bottom" title="Search Image"><i class="fas fa-file-upload"></i>&nbsp;Search</button>-->
        </div>
      </div>

      <div class="title-hdr bg-dark">
        CKOne Download Mobile Apps
      </div>

      <!--<div class="progress" v-if="progressing">
        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width:100%"></div>
      </div>-->

      <div class="card">
        <div class="card-body">
          <div class="container-fluid container-fluid-max">
            <div class="row text-center pb-5">
              <div class="col-12 pb-4 pt-5">
                <div class="pb-3">
                  <img src="static/images/ck_logo_black.png" class="responsive-logo" />
                </div>
                <h3>CKOne Mobile App</h3>
                <h4>Download Below</h4>
              </div>
              <template v-if="deviceType === 'ios' || deviceType === 'all'">
                <div class="col-12 col-sm-6 col-lg-6">
                  <a :href="'itms-services://?action=download-manifest&url='+baseUrl+'/downloads/ckone/ios/Info.plist'"><img
                      src="static/icons/ios.png" style="height: 100px; width: 100px;"></a>
                  <h3 class="mt-3 text-red h4">CKOne IOS</h3>
                  <div class="col-12 mt-5">
                    <h4>How to Download CKOne iOS App</h4>
                    <ol class="download-instructions">
                      <li>
                        <strong>Step 1:</strong> Tap the <img src="static/icons/ios.png" alt="iOS icon"
                                                              style="height:20px; width:20px; vertical-align:middle; margin:0 5px;">
                        icon above to start the download.
                      </li>
                      <li>
                        <strong>Step 2:</strong> When prompted, choose <em>Install</em> to add the app to your device.
                        <div class="instruction-image">
                          <img src="static/images/ios/s1.jpg" alt="Install prompt screenshot"/>
                        </div>
                      </li>
                      <li>
                        <strong>Step 3:</strong> After installation, go to <em>Settings &gt; General &gt; Device
                        Management</em> and
                        trust the developer profile.
                        <div class="instruction-image">
                          <img src="static/images/ios/s2.jpg" alt="Trust developer profile screenshot"/>
                          <img src="static/images/ios/s3.jpg" alt="Trust developer profile screenshot"/>
                          <img src="static/images/ios/s4.jpg" alt="Trust developer profile screenshot"/>
                          <img src="static/images/ios/s5.jpg" alt="Trust developer profile screenshot"/>
                          <img src="static/images/ios/s6.jpg" alt="Trust developer profile screenshot"/>
                          <img src="static/images/ios/s7.jpg" alt="Trust developer profile screenshot"/>
                        </div>
                      </li>
                      <li>
                        <strong>Step 4:</strong> Open the CKOne app from your home screen and start using it.
                        <div class="instruction-image">
                          <img src="static/images/ios/s8.jpg" alt="Open app screenshot"/>
                        </div>
                      </li>
                    </ol>
                  </div>
                </div>
              </template>
              <template v-if="deviceType === 'android' || deviceType === 'all'">
                <div class="col-12 col-sm-6 col-lg-6">
                  <a :href="baseUrl+'/downloads/ckone/android/ckonex.apk'" download><img src="static/icons/android.png"
                                                                                         style="height: 100px; width: 100px;"></a>
                  <h3 class="mt-3 text-red h4">CKOne Android</h3>
                  <div class="col-12 mt-5">
                    <h4>How to Download CKOne Android App</h4>
                    <ol class="download-instructions">
                      <li>
                        <strong>Step 1:</strong> Tap the <img src="static/icons/android.png" alt="Android icon"
                                                              style="height:20px; width:20px; vertical-align:middle; margin:0 5px;">
                        icon above to download the APK file.
                      </li>
                      <li>
                        <strong>Step 2:</strong> When the download completes, open the APK file from your notification
                        bar
                        or file manager.
                        <div class="instruction-image">
                          <img src="static/images/android/s1.jpg" alt="Open APK file screenshot"/>
                        </div>
                      </li>
                      <li>
                        <strong>Step 3:</strong> If prompted, enable <em>Install from Unknown Sources</em> in your
                        device
                        settings.
                        <div class="instruction-image">
                          <img src="static/images/android/s2.jpg"
                               alt="Enable unknown sources screenshot"/>
                        </div>
                      </li>
                      <li>
                        <strong>Step 4:</strong> Follow the on-screen instructions to install the CKOne app.
                        <div class="instruction-image">
                          <img src="static/images/android/s3.jpg" alt="Install app screenshot"/>
                        </div>
                      </li>
                      <li>
                        <strong>Step 5:</strong> Once installed, open the CKOne app from your app drawer and start using
                        it.
                        <div class="instruction-image">
                          <img src="static/images/android/s4.jpg" alt="Open app screenshot"/>
                        </div>
                      </li>
                    </ol>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import axios from 'axios'
  import { baseUrl } from './../../../.env.js'
  import { bus } from '../../../main.js'

  export default {
    name: 'CKOne',
    data() {
      return {
        // certs: {},
        baseUrl: baseUrl,
        deviceType: 'all' // 'ios', 'android', or 'all'
      }
    },
    mounted() {
      this.detectDevice();
      // var vm = this;
      // $.getJSON(baseUrl+"/downloads/xstore/certificates/certs.json", function(data){
      //   vm.certs = data;
      // });
      console.log(baseUrl)
      //this.$store.commit('selectedTab', 'xstore');
    },
    methods: {
      detectDevice() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // iOS detection
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          this.deviceType = 'ios';
        }
        // Android detection
        else if (/android/i.test(userAgent)) {
          this.deviceType = 'android';
        } else {
          this.deviceType = 'all'; // fallback: show both
        }
      }
    }
  }
</script>

<style>
.responsive-logo {
  height: auto;
  width: 400px;
}

@media (max-width: 768px) {
  .responsive-logo {
    height: auto;
    width: 450px;
  }
}

@media (max-width: 576px) {
  .responsive-logo {
    height: auto;
    width: 400px;
  }
}

.download-instructions {
  list-style-type: decimal;
  padding-left: 20px;
  font-size: 1rem;
  color: #333;
}

.download-instructions li {
  margin-bottom: 1.5rem;
}

.instruction-image img {
  max-width: 100%;
  height: auto;
  margin-top: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobileapps/main/CKOne.vue